export default "__VITE_ASSET__DzQtHb34__"